<template>
    <div class="columns honoree-location-info push-top" v-if="honoree.wall">
        <div class="column map">
            <div class="display" v-if="honoree" v-for="idx in 6" :key="idx" :class="setMapClasses(idx)">
                <span>{{idx}}</span>
            </div>
        </div>
        <div class="column wall-grid">
            <div v-for="i in columnCounts[honoree.wall]" :key="i">
                <div class="block" v-for="idx in 4" :key="idx" :class="{active: i === honoree.col && idx === honoree.row}"></div>
            </div>
        </div>
        <p class="is-size-4" v-if="honoree.wall">{{honoree.wall | formattedWall}}, Row {{honoree.row}}, Column {{honoree.col}}.</p>
    </div>
</template>

<script>
export default {
    name: 'wall-info',
    props: ['honoree'],
    data() {
        return {
            columnCounts: {
                'wall-1': 10,
                'wall-2': 14,
                'wall-3': 6,
                'wall-4': 5,
                'padres-wall-left': 4,
                'padres-wall-right': 1
            }
        }
    },
    methods: {
        setMapClasses(idx) {
            if (!this.honoree.wall) return;
            let classNames = [];
            classNames.push(`display-${idx}`);
            idx < 3 ? classNames.push('tall') : classNames.push('short');
            this.honoree.wall.indexOf(idx) != -1
                ? classNames.push('active')
                : classNames.push('');
            this.honoree.wall.indexOf('left') != -1 && idx === 5
                ? classNames.push('active')
                : classNames.push('');
            this.honoree.wall.indexOf('right') != -1 && idx === 6
                ? classNames.push('active')
                : classNames.push('');
            return classNames;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/helpers.scss';

.map {
  position: relative;
  width: 100%;
  height: 306px;
  background: url('/images/map.png') no-repeat;
}
.map .display {
  position: absolute;
  background-color: #999999;
}
.map .display.active {
  background-color: $gold;
}
.map .display.tall {
  width: 7px;
  height: 60px;
  left: 22px;

  span {
    top: 38%;
    left: 3px;
  }
}
.map .display.short {
  height: 10px;
}
.map .display.display-1 {
  top: 155px;
}
.map .display.display-2 {
  top: 50px;
  height: 75px;
}
.map .display.display-3,
.map .display.display-4 {
  width: 7px;
  height: 30px;
  top: 92px;
  left: 117px;
}

.map .display.display-4 {
  top: 140px;
}

.map .display.display-3 span {
  top: -8px;
  left: -14px;
}

.map .display.display-4 span {
  top: 7px;
  left: -14px;
}

.map .display.display-5,
.map .display.display-6 {
  width: 30px;
  height: 7px;
  top: 0px;
  left: 122px;

  span {
    top: 5px;
    left: 7px;
  }
}

.map .display.display-6 {
  left: 188px;
}
.map .display span {
  position: absolute;
  background-color: $red;
  border-radius: 50%;
  padding: 0 6px;
  font-size: 12px;
}
.wall-grid {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 650px;
  height: 285px;
  padding: 25px;
  background-color: #fff;
  > div {
    margin: 0 5px;
  }
  @media screen and (max-width: 768px) {
    margin-top: 25px;
  }
  @media screen and (max-width: 500px) {
    padding: 5px;
    height: 200px;
  }
  @media screen and (max-width: 400px) {
    > div {
      margin: 0 1px;
    }
  }
  + p {
    padding-left: 10px;
  }  
}
.block {
  width: 30px;
  height: 40px;
  margin: 10px 0;
  background-color: #b3b3b3;
  @media screen and (max-width: 500px) {
    width: 20px;
    height: 30px;
  }
}
.block.active {
  background-color: $gold;
}
</style>